import { IconButton, Pagination } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";
import { DataGrid, GridToolbarColumnsButton } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { getPermissionData, getUserData } from "../../Actions/common";
import {
    deleteTenantByIdAction,
    deleteMultipleTenantByIdAction,
    getTenantAction,
    updateTenantStatusAction,
    updateTenantAutopayAction,
    renewTenantPlanAction,
    getTenantCurrenciesAction,
    getTenantDetailByIdAction,
} from "../../Actions/TenantActions";
import { getSubscriptionPlanAction } from "../../Actions/SubscriptionPlansAction";
import { DataGrid_SX } from "../../Assets/customTheme/constants";
import { CustomNoRowsOverlay } from "../../Assets/customTheme/CustomNoRowsOverlay";
import { CustomSwitch } from "../../Assets/customTheme/customswitch";
import {
    default as CoustomTooltip,
    default as CustomTooltip,
} from "../../Assets/customTheme/customtooltip";
import { MyAddRoundedIcon, MyAutorenewIcon, MyDeleteOutlineOutlinedIcon, MyEditOutlinedIcon, MySearchIcon } from "../../Assets/svg/MyIcons";
import { TableColumns, TableFilte, TableReset } from "../../Assets/svg/svgicon";
import BreadcrumbsComponent from "../../components/Common/Breadcrumbs";
import { ITEMS_PER_PAGE_OPTIONS } from "../../config";
import { formatDateTime } from "../Common/DateFormat";
import CustomSnackbar from "../Common/snackBar";
import { CommonTooltip } from "../../utils/tooltip";
import { renderStatusBadge } from "../../utils/badges";
import showConfirmation from "../../utils/Conformation";
import PowerSettingsNewOutlinedIcon from "@mui/icons-material/PowerSettingsNewOutlined";


const CustomToolbar = ({
    selectedRows,
    handleDeleteSelected,
    searchValue,
    handleSearchApi,
    handleFilterData,
    handleResetFilters,
    handleChangeDropdown,
    statusFilter,
    hasPermission,
    filterButtonDisabled,
    resetButtonDisabled,
}) => {
    const navigate = useNavigate(); // Initialize the navigate function

    const handleAddButtonClick = () => {
        navigate("/tenant/add");
    };

    return (
        <div className="custom-header">
            <div className="card border-rounded-0 fiter-card">
                <div className="card-body p-5 pb-0">
                    <div className="row">
                        <div className="col-xl-3 col-xxl-2 col-lg-3 col-md-4 col-sm-6 mb-5">
                            <div className="input-group w-100">
                                <div className="input-group-prepend">
                                    <span
                                        className="input-group-text"
                                        id="basic-addon1"
                                    >
                                        <MySearchIcon />
                                    </span>
                                </div>
                                <input
                                    type="text"
                                    data-kt-table-widget-4="search"
                                    className="form-control"
                                    placeholder="Search"
                                    name="search"
                                    value={searchValue}
                                    onChange={handleSearchApi}
                                />
                            </div>
                        </div>

                        <div className="col-xl-3 col-xxl-2 col-lg-3 col-md-3 col-sm-6 mb-5">
                            <FormControl className="w-100">
                                <Select
                                    displayEmpty
                                    value={statusFilter}
                                    name="dropdown"
                                    onChange={(e) =>
                                        handleChangeDropdown(e, "status")
                                    }
                                    input={<OutlinedInput />}
                                    sx={{
                                        "& .MuiSelect-select": {
                                            padding: "12px 10px",
                                            textAlign: "start",
                                            minHeight: "1em !important",
                                        },
                                        fieldset: {
                                            borderColor: "#e1e3ea !important",
                                            borderRadius: "0.475rem",
                                        },
                                    }}
                                >
                                    <MenuItem value="all">All Status</MenuItem>
                                    <MenuItem value="1">Active</MenuItem>
                                    <MenuItem value="0">Not Active</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                        <div className="col-auto ms-auto">
                            <div className="d-flex align-items-center gap-3">
                                <CustomTooltip
                                    title="Filter"
                                    placement="top"
                                    arrow
                                >
                                    <span>
                                    <button
                                        className="btn text-primary btn-light btn-icon"
                                        onClick={handleFilterData}
                                        disabled={filterButtonDisabled}
                                    >
                                        <TableFilte />
                                    </button>
                                    </span>
                                </CustomTooltip>
                                <CustomTooltip
                                    title="Reset"
                                    placement="top"
                                    arrow
                                >
                                    <span>
                                    <button
                                        className="btn  text-primary btn-light btn-icon"
                                        onClick={handleResetFilters}
                                        disabled={resetButtonDisabled}
                                    >
                                        <TableReset />
                                    </button>
                                    </span>
                                </CustomTooltip>
                                <CoustomTooltip
                                    title="Column Filter"
                                    placement="top"
                                    arrow
                                >
                                    <span style={{ display: "inline-block" }}>
                                    <GridToolbarColumnsButton
                                        slotProps={{
                                        tooltip: { title: "" },
                                        button: {
                                            className: "btn btn-light text-primary btn-icon grid-toolbar d-flex justify-content-center align-items-center p-0",
                                            style: {
                                            width: "47px",
                                            height: "44px",
                                            minWidth: "unset",
                                            borderRadius: "8px",
                                            },
                                            startIcon: <TableColumns />,
                                        },
                                        }}
                                    />
                                    </span>
                                </CoustomTooltip>
                                {selectedRows.length !== 0 && (
                                    <CoustomTooltip
                                        title="Delete"
                                        placement="top"
                                        arrow
                                    >
                                        <span>
                                            <button
                                                className="btn btn-outline-danger btn-icon btn-outline"
                                                onClick={handleDeleteSelected}
                                                disabled={
                                                    selectedRows.length === 0
                                                }
                                            >
                                                <MyDeleteOutlineOutlinedIcon />
                                            </button>
                                        </span>
                                    </CoustomTooltip>
                                )}
                                {hasPermission?.canCreate && (
                                    <button
                                        className="btn btn-outline btn-primary btn-add "
                                        onClick={handleAddButtonClick}
                                    >
                                        <MyAddRoundedIcon className="me-1 text-white" /> ADD
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const TenantSection = () => {
    const [MerchantData, setMerchantData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [searchValue, setSearchValue] = useState("");
    const [loading, setLoading] = useState(true);
    const [filterButtonDisabled, setFilterButtonDisabled] = useState(true);
    const [resetButtonDisabled, setResetButtonDisabled] = useState(true);
    const [statusFilter, setStatusFilter] = useState("all");
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success",
    });
    const navigate = useNavigate();
    const [selectedRows, setSelectedRows] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [shouldFetchData, setShouldFetchData] = useState(1);
    const [selectedRowsPerPage, setSelectedRowsPerPage] = useState(
        ITEMS_PER_PAGE_OPTIONS[0]
    );

    const userData = localStorage.getItem("userData") ? getUserData() : null;
    const permissionData = localStorage.getItem(
        `${userData?.id}_permissionData`
    )
        ? getPermissionData(`${userData?.id}_permissionData`)
        : [];
    const hasPermission = permissionData[0]?.role_permissions?.find(
        (m) => m?.module && m?.module?.slug === "onboarding-tenant"
    );


    useEffect(() => {
        if (shouldFetchData) {
            getMerchantData();
            setShouldFetchData(0);
        }
        // eslint-disable-next-line
    }, [shouldFetchData]);

    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };

    const getMerchantData = async () => {
        setLoading(true);
        await getTenantAction(
            currentPage,
            searchValue,
            selectedRowsPerPage,
            statusFilter
        )
            .then((res) => {
                const { data, totalRecords } = res.data;
                setMerchantData(data);
                setTotalRecords(totalRecords);
                setLoading(false);
            })
            .catch((error) => {
                setSnackbar({
                    open: true,
                    message: error.response.data.message,
                    severity: "error",
                });
            });
        setLoading(false);
    };

    const handleDeleteTenant = async (e, deleteId) => {  
        e.stopPropagation();

        await showConfirmation("delete", {
            entityName: "Tenant",
            entityId: deleteId,
            action: async ({ deleteId, deleteType }) => {
                return await deleteTenantByIdAction({ deleteId, deleteType });
            },
            onSuccess: (res, deleteType) => {
                setSnackbar({
                    open: true,
                    message: res?.message || res?.data?.message || `Tenant ${deleteType} deleted successfully`,
                    severity: "success",
                });
                getMerchantData();
            },
            onError: (error) => {
                setSnackbar({
                    open: true,
                    message: error?.response?.data?.message || "Something went wrong",
                    severity: "error",
                });
            },
            showCancelledMsg: true, 
        });
    };

    const handleSearchApi = (e) => {
        const inputValue = e.target.value.trim();
        if (inputValue.length === 0) {
            setFilterButtonDisabled(true);
        } else {
            setFilterButtonDisabled(false);
        }
        setSearchValue(inputValue);
    };

    const changeMerchantStatus = async (e, ele) => {
        e.stopPropagation();

        const newStatus = !ele.isActive;
        const actionText = newStatus ? "Activate" : "Deactivate";

        const result = await Swal.fire({
            title: `${actionText} Tenant?`,
            text: `Are you sure you want to ${actionText.toLowerCase()} this tenant?`,
            icon: newStatus ? "question" : "warning",
            showCancelButton: true,
            confirmButtonColor: newStatus ? "#28a745" : "#dc3545",
            cancelButtonColor: "#777777",
            confirmButtonText: `Yes, ${actionText}`,
            cancelButtonText: "Cancel",
        });

        if (result.isConfirmed) {
            await updateTenantStatusAction(ele.id, ele.isActive)
                .then((res) => {
                    setSnackbar({
                        open: true,
                        message: res.data.message,
                        severity: "success",
                    });
                    getMerchantData();
                })
                .catch((error) => {
                    setSnackbar({
                        open: true,
                        message: error.response.data.message,
                        severity: "error",
                    });
                });
        }
    };

    const changeTenantAutopay = async (e, ele) => {
        e.stopPropagation();
        const newAutopayStatus = !ele.isAutoPay;

        await showConfirmation("customToggle", {
            entityName: "Subscription",
            entityId: ele.id,
            isActivating: newAutopayStatus,
            action: updateTenantAutopayAction,
            customTitle: newAutopayStatus ? "Enable Subscription?" : "Disable Subscription?",
            customHtml: newAutopayStatus
                ? `
                    <p class="mb-3">Are you sure you want to enable subscription for <strong>${ele.companyName}</strong>?</p>
                    <div class="alert alert-info bg-info-subtle border border-info-subtle text-start p-3 mb-0">
                        <strong>Note:</strong> This will be applicable from the next billing cycle.
                    </div>
                `
                : `
                    <p class="mb-3">Are you sure you want to disable subscription for <strong>${ele.companyName}</strong>?</p>
                    <div class="alert alert-warning bg-warning-subtle border border-warning-subtle text-start p-3 mb-0">
                        <strong>Warning:</strong> Once disabled, payments will need to be processed manually.
                    </div>
                `,
            confirmButtonText: newAutopayStatus ? "Yes, Enable Subscription" : "Yes, Disable Subscription",
            confirmButtonColor: newAutopayStatus ? "#22419e" : "#dc3545",
            onSuccess: (res) => {
                setSnackbar({
                    open: true,
                    message: res?.message || `Subscription ${newAutopayStatus ? "enabled" : "disabled"} successfully`,
                    severity: "success",
                });
                getMerchantData();
            },
            onError: (error) => {
                setSnackbar({
                    open: true,
                    message: error?.response?.data?.message || "Something went wrong",
                    severity: "error",
                });
            },
        });
    };

    // const handleRowSelection = (event, ele) => {
    //     const selectedId = ele.id;

    //     if (event.target.checked) {
    //         setSelectedRows((prevSelectedRows) => [
    //             ...prevSelectedRows,
    //             selectedId,
    //         ]);
    //     } else {
    //         setSelectedRows((prevSelectedRows) =>
    //             prevSelectedRows.filter((id) => id !== selectedId)
    //         );
    //     }
    // };

    // const handleSelectAll = (event) => {
    //     if (event.target.checked) {
    //         const allIds = MerchantData.map((ele) => ele.id);
    //         setSelectedRows(allIds);
    //     } else {
    //         setSelectedRows([]);
    //     }
    // };

    const handleDeleteSelected = () => {
        if (selectedRows.length === 0) {
            return;
        }

        Swal.fire({
            title: "Are you sure you want to delete selected Tenants?",
            html: `
                <p class="mb-3">You will not be able to recover these tenants.</p>

                <div class="alert alert-warning bg-warning-subtle border border-warning-subtle text-start p-3 mb-0 text-muted
">
                    <div class="mb-2">
                        <strong class="text-danger">Hard Delete</strong>
                        <p class="mb-1">
                            Permanently removes selected tenants and
                            <strong>all their transactions</strong>.
                        </p>
                    </div>
                    <hr>
                    <div>
                        <strong class="text-primary">Soft Delete</strong>
                        <p class="mb-0">
                            Deactivates tenants while preserving
                            <strong>transaction history</strong>.
                        </p>
                    </div>
                </div>
            `,
            icon: "warning",
            showCancelButton: true,
            showDenyButton: true,
            confirmButtonColor: "#d33", // Hard Delete = red
            denyButtonColor: "#22419e", // Soft Delete = blue
            cancelButtonColor: "#777777",
            confirmButtonText: "Hard Delete",
            denyButtonText: "Soft Delete",
            cancelButtonText: "Cancel",
        }).then(async (result) => {
            let deleteType = null;

            if (result.isConfirmed) deleteType = "hard";
            if (result.isDenied) deleteType = "soft";

            if (deleteType) {
                try {
                    await deleteMultipleTenantByIdAction({
                        selectedRows,
                        deleteType,
                    })
                        .then((res) => {
                            Swal.fire({
                                title: "Deleted!",
                                text: res.data.message,
                                icon: "success",
                                confirmButtonColor: "#22419e",
                            });
                            setSelectedRows([]);
                            setCurrentPage(1);
                            getMerchantData();
                        })
                        .catch((error) => {
                            setSnackbar({
                                open: true,
                                message: error.response.data.message,
                                severity: "error",
                            });
                            setSelectedRows([]);
                        });
                } catch (error) {
                    console.error(
                        "Error -> Something went wrong while multiple delete"
                    );
                }
            } else {
                Swal.fire({
                    title: "Cancelled",
                    text: "Your record is safe",
                    icon: "error",
                    confirmButtonColor: "#22419e",
                });
                setSelectedRows([]);
            }
        });
    };

    const handlePaginationChange = (event, value) => {
        setMerchantData([]);
        setSelectedRows([]);
        setCurrentPage(value);
        setShouldFetchData(1);
    };

    const handleChangeDropdown = (e, filterName) => {
        const selectedAction = e.target.value;
        if (selectedAction === "all") {
            setFilterButtonDisabled(true);
        } else {
            setFilterButtonDisabled(false);
        }
        if (filterName === "status") {
            setStatusFilter(selectedAction);
        }
    };

    const handleResetFilters = () => {
        setMerchantData([]);
        setStatusFilter("all");
        setSearchValue("");
        setCurrentPage(1);
        setShouldFetchData(1);
        setResetButtonDisabled(true);
        setFilterButtonDisabled(true);
    };

    const handleFilterData = () => {
        setLoading(true);
        setCurrentPage(1);
        setShouldFetchData(1);
        setMerchantData([]);
        setLoading(false);
        setFilterButtonDisabled(true);
        setResetButtonDisabled(false);
    };

    const handleSelectId = (id) => {
        navigate("/tenant/edit", {
            state: {
                id: id,
            },
        });
    };

    const handleRowsPerPageChange = (event) => {
        setMerchantData([]);
        setSelectedRows([]);
        const newValue = parseInt(event.target.value);
        setSelectedRowsPerPage(newValue);
        setCurrentPage(1);
        setLoading(true);
        setShouldFetchData(1);
    };

    const handleRenewPlan = async (e, tenant) => {
        e.stopPropagation();

        try {
            // Fetch full tenant details to get billingCycle from plan history
            const [planResponse, currencyResponse, tenantDetailRes] = await Promise.all([
                getSubscriptionPlanAction(1, "", 100, "all"),
                getTenantCurrenciesAction(),
                getTenantDetailByIdAction(tenant.id),
            ]);

            const plans = planResponse?.data?.data || [];
            const currentPlan = plans.find(p => p.id === tenant.planId);
            
            if (!currentPlan) {
                setSnackbar({
                    open: true,
                    message: "Plan details not found",
                    severity: "error",
                });
                return;
            }

            // Get currency symbol
            const currencies = currencyResponse?.data?.data || [];
            const currency = currencies.find(c => c.id === tenant.currency);
            const currencySymbol = currency?.symbol || "$";

            // Use the billing cycle from the tenant's last plan history record
            const billingCycle = tenantDetailRes?.data?.billingCycle || "monthly";
            const planAmount = billingCycle === "yearly"
                ? currentPlan.yearly_price
                : currentPlan.monthly_price;

            // For custom plans, use the custom plan price; otherwise use the plan's billing-cycle price
            const isCustomPlan = tenant.isCustomPlan && tenant.customPlanId;
            const customPlanDetails = tenantDetailRes?.data?.customPlanDetails;
            const displayAmount = isCustomPlan && customPlanDetails?.price
                ? customPlanDetails.price
                : planAmount;

            const result = await Swal.fire({
                title: "Renew Plan Confirmation",
                html: `
                    <div class="text-start">
                        <p class="mb-4">Please review the plan renewal details for <strong>${tenant.companyName}</strong>:</p>
                        
                        <div class="card border mb-3">
                            <div class="card-body p-3">
                                <h6 class="card-title mb-3 text-primary">Plan Details</h6>
                                <div class="row mb-2">
                                    <div class="col-6 text-muted">Plan Name:</div>
                                    <div class="col-6 fw-semibold">${currentPlan.name}</div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col-6 text-muted">Billing Cycle:</div>
                                    <div class="col-6 fw-semibold text-capitalize">${billingCycle}</div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col-6 text-muted">Payment Mode:</div>
                                    <div class="col-6 fw-semibold text-capitalize">${tenant.paymentMode || "online"}</div>
                                </div>
                                <hr class="my-2">
                                <div class="row">
                                    <div class="col-6 text-muted fw-bold">Total Amount:</div>
                                    <div class="col-6 fw-bold text-primary fs-5">${currencySymbol}${displayAmount}</div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="alert alert-info mb-0">
                            <strong>Note:</strong> ${tenant.paymentMode === "online" 
                                ? "A payment link will be sent to your registered email address." 
                                : "Your renewal request will be processed manually by our team."}
                        </div>
                    </div>
                `,
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#22419e",
                cancelButtonColor: "#777777",
                confirmButtonText: "Yes, Renew Plan",
                cancelButtonText: "Cancel",
                width: "600px",
            });

            if (result.isConfirmed) {
                const renewData = {
                    tenantId: tenant.id,
                    planId: tenant.planId,
                    billingCycle: billingCycle,
                    paymentMode: tenant.paymentMode || "online",
                    isAutoPay: tenant.isAutoPay || false,
                    isCustomPlan: tenant.isCustomPlan || false,
                    customPlanDetails: tenant.customPlanId && tenant.customPlanDetails ? {
                        messageLimit: tenant.message_limit,
                        userLimit: tenant.user_limit,
                        agentLimit: tenant.agent_limit,
                        price: tenant.customPlanDetails?.price || null,
                        currency: tenant.customPlanDetails?.currency || tenant.currency,
                    } : (tenant.customPlanId ? {
                        messageLimit: tenant.message_limit,
                        userLimit: tenant.user_limit,
                        agentLimit: tenant.agent_limit,
                    } : null),
                    allowedFeatures: tenant.allowedFeatures || {},
                };

                const response = await renewTenantPlanAction(renewData);

                Swal.fire({
                    title: "Success!",
                    html: `
                        <div class="text-center">
                            <p class="mb-3">${response.message || "Plan renewal request has been submitted successfully"}</p>
                            ${tenant.paymentMode === "online" 
                                ? `<div class="alert alert-success">
                                    Payment link has been sent to <strong>${tenant.companyEmail}</strong>
                                   </div>` 
                                : `<div class="alert alert-info">
                                    Your request is being processed. You will be notified once approved.
                                   </div>`}
                        </div>
                    `,
                    icon: "success",
                    confirmButtonColor: "#22419e",
                });

                getMerchantData();
            }
        } catch (error) {
            console.error("Renewal error:", error);
            setSnackbar({
                open: true,
                message: error?.response?.data?.message || "Failed to renew plan",
                severity: "error",
            });
        }
    };

    const columns = [
        // {
        //     field: "id",
        //     headerName: "",
        //     sortable: false,
        //     filterable: false,
        //     disableColumnMenu: true,
        //     minWidth: 50,
        //     flex: 0.5,
        //     renderHeader: () => (
        //         <Checkbox
        //             onChange={handleSelectAll}
        //             disabled={MerchantData.length === 0}
        //             checked={
        //                 MerchantData.length > 0 &&
        //                 selectedRows.length === MerchantData.length
        //             }
        //             sx={MyCheckboxIcon}
        //         />
        //     ),
        //     renderCell: (params) => (
        //         <Checkbox
        //             onChange={(event) => handleRowSelection(event, params.row)}
        //             checked={selectedRows.includes(params.row.id)}
        //             sx={MyCheckboxIcon}
        //         />
        //     ),
        // },
        {
            field: "companyName",
            headerName: "Company Name",
            minWidth: 150,
            flex: 1.5,
            renderCell: (params) => (
                <span style={{ fontSize: 15, color: "#333" }}>
                    {params.row.companyName || "-"}
                </span>
            ),
        },
        {
            field: "domainUrl",
            headerName: "Domain",
            minWidth: 150,
            flex: 1.5,
            renderCell: (params) => (
                <span style={{ fontSize: 15, color: "#333" }}>
                    {params.row.domainUrl || "-"}
                </span>
            ),
        },
        {
            field: "companyEmail",
            headerName: "Company Email",
            minWidth: 180,
            flex: 1.5,
            renderCell: (params) => (
                <span style={{ fontSize: 15, color: "#333" }}>
                    {params.row.companyEmail || "-"}
                </span>
            ),
        },
        {
            field: "name",
            headerName: "Name",
            minWidth: 180,
            flex: 2,
            renderCell: (params) => {
                return (
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <span
                            style={{
                                fontSize: 15,
                                fontWeight: 500,
                                color: "#333",
                            }}
                        >
                            {params.row.firstName} {params.row.lastName}
                        </span>
                    </div>
                );
            },
        },
        {
            field: "companyPhoneNumber",
            headerName: "Phone Number",
            minWidth: 130,
            flex: 1.2,
            renderCell: (params) => (
                <span style={{ fontSize: 15, color: "#333" }}>
                    {params.row.companyPhoneNumber || "-"}
                </span>
            ),
        },
        {
            field: "isAutoPay",
            headerName: "Subscription",
            minWidth: 120,
            flex: 0.8,
            renderCell: (params) => (
                <CustomSwitch
                    checked={params.row.isAutoPay}
                    onClick={(e) => changeTenantAutopay(e, params.row)}
                />
            ),
        },
        {
            field: "status",
            headerName: "Status",
            minWidth: 120,
            flex: 1,
            renderCell: (params) => {
                const statusMap = {
                    0: { text: "Pending", status: "warning" },
                    1: { text: "In Progress", status: "info" },
                    2: { text: "Approved", status: "success" },
                };
                const statusCode = params.row?.status ?? "0";
                const { text, status } = statusMap[statusCode] || {
                    text: "Unknown",
                    status: "default",
                };
                return renderStatusBadge({ status, title: text });
            },
        },
        {
            field: "updatedAt",
            headerName: "Updated Date",
            minWidth: 150,
            flex: 1.2,
            renderCell: (params) => (
                <span style={{ fontSize: 14, fontWeight: 400, color: "#555" }}>
                    {params.row.updatedAt
                        ? formatDateTime(params.row.updatedAt, true)
                        : "N/A"}
                </span>
            ),
        },
        {
            field: "renew",
            headerName: "Renew Plan",
            minWidth: 120,
            flex: 1,
            sortable: false,
            align: "center",
            headerAlign: "center",
            renderCell: (params) => {
                // Use isPlanExpired from backend response
                const isPlanExpired = params.row?.isPlanExpired || false;

                return isPlanExpired ? (
                    <>
                        {hasPermission?.canEdit && (
                            <CommonTooltip title="Renew Plan" placement="top" arrow>
                                <IconButton
                                    className="btn-custom-i text-primary me-3"
                                    onClick={(e) => handleRenewPlan(e, params.row)}
                                >
                                    <MyAutorenewIcon />
                                </IconButton>
                            </CommonTooltip>
                        )}
                    </>
                ) : (
                    renderStatusBadge({ status: "success", title: "Active" })
                );
            },
        },
        ...(hasPermission?.canEdit || hasPermission?.canDelete
        ? [
            {
                field: "actions",
                headerName: "Actions",
                minWidth: 150,
                flex: 1,
                sortable: false,
                align: "center",
                headerAlign: "center",
                renderCell: (params) => (
                    <div 
                        className="d-flex align-items-center justify-content-center w-100 h-100"
                    >
                        {hasPermission?.canEdit && (
                            <CommonTooltip title={params.row?.isActive ? "Deactivate Tenant" : "Activate Tenant"}>
                                <IconButton
                                    className="btn-custom-i text-primary me-3"
                                    onClick={(e) => changeMerchantStatus(e, params.row)}
                                >
                                    <PowerSettingsNewOutlinedIcon
                                        color={params.row?.isActive ? "error" : "success"}
                                    />
                                </IconButton>
                            </CommonTooltip>
                        )}

                        {hasPermission?.canEdit && (
                            <CommonTooltip title="Edit" placement="top" arrow>
                                <IconButton
                                    className="btn-custom-i text-primary me-3"
                                    onClick={() => handleSelectId(params.row.id)}
                                >
                                    <MyEditOutlinedIcon />
                                </IconButton>
                            </CommonTooltip>
                        )}
                        {hasPermission?.canDelete && (
                            <CommonTooltip title="Delete" placement="top" arrow>
                                <IconButton
                                    className="btn-custom-i text-primary"
                                    onClick={(e) => handleDeleteTenant(e, params.row.id)}
                                >
                                    <MyDeleteOutlineOutlinedIcon fontSize="small" />
                                </IconButton>
                            </CommonTooltip>
                        )}
                    </div>
                ),
            },
        ]
      : []),
    ]
    return (
        <div id="kt_content_container">
            <BreadcrumbsComponent />

            <DataGrid
                className="border-0"
                localeText={{ toolbarColumns: "" }}
                rows={MerchantData}
                columns={columns}
                autoHeight
                hideFooterRowCount={true}
                hideFooterPagination={true}
                hideFooter={true}
                loading={loading}
                slots={{
                    toolbar: CustomToolbar,
                    noRowsOverlay: CustomNoRowsOverlay,
                }}
                slotProps={{
                    toolbar: {
                        selectedRows,
                        handleDeleteSelected,
                        searchValue,
                        handleSearchApi,
                        handleFilterData,
                        handleResetFilters,
                        handleChangeDropdown,
                        statusFilter,
                        MerchantData,
                        hasPermission,
                        filterButtonDisabled,
                        resetButtonDisabled,
                    },
                }}
                components={{
                    loadingOverlay: () => (
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                height: "100px",
                            }}
                        >
                            <CircularProgress
                                color="primary"
                                size={24}
                                style={{
                                    marginRight: 10,
                                }}
                            />
                            Loading...
                        </div>
                    ),
                    noRowsOverlay: () =>
                        loading ? null : (
                            <div
                                style={{
                                    display:
                                        !loading && MerchantData.length === 0
                                            ? "block"
                                            : "none",
                                    fontWeight: "bold",
                                    textAlign: "center",
                                    padding: "20px",
                                }}
                            >
                                No Records Found
                            </div>
                        ),
                }}
                sx={DataGrid_SX}
            />

            <div className="card-footer d-flex align-items-center justify-content-between mt-7">
                <div className="d-flex align-items-center">
                    <label className="fw-semibold me-3">
                        {"Row per page"}{" "}
                    </label>
                    <FormControl
                        variant="standard"
                        style={{
                            minWidth: 50,
                        }}
                    >
                        <Select
                            labelId="rows-per-page-label"
                            id="rows-per-page"
                            value={selectedRowsPerPage}
                            onChange={handleRowsPerPageChange}
                            label="Row per page"
                        >
                            {ITEMS_PER_PAGE_OPTIONS?.map((option) => (
                                <MenuItem key={option} value={option}>
                                    {option}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div>
                <Pagination
                    count={Math.ceil(totalRecords / selectedRowsPerPage)}
                    siblingCount={0}
                    page={currentPage}
                    onChange={(event, value) =>
                        value !== currentPage
                            ? handlePaginationChange(event, value)
                            : null
                    }
                    variant="outlined"
                    shape="rounded"
                    className="custom-pagination mt-0 ms-5"
                />
            </div>
            <CustomSnackbar
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                onClose={handleCloseSnackbar}
            />
        </div>
    );
};

export default TenantSection;
